import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { SERVICES } from "@/lib/data";

const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        caption="Nos solutions"
        title="Trois façons de financer votre croissance"
        subtitle="Chaque entreprise est différente. On bâtit la structure de financement qui respecte votre trésorerie, votre saisonnalité et vos ambitions."
      />

      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {SERVICES.map((service, i) => (
          <Reveal key={service.number} delay={i * 0.12}>
            <article
              data-testid={`service-card-${i}`}
              className="group relative h-full rounded-2xl border border-slate-900/10 bg-white spotlight-card p-8 transition-all duration-500 hover:border-sky-400/50 hover:-translate-y-2"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-extrabold text-slate-900/10 group-hover:text-sky-600/30 transition-colors duration-500">
                  {service.number}
                </span>
                <span className="rounded-full bg-sky-400/15 border border-sky-400/30 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-sky-600">
                  {service.tag}
                </span>
              </div>
              <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-slate-900 mt-6">
                {service.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed mt-3">{service.description}</p>
              <ul className="mt-6 space-y-3">
                {service.highlights.map((h) => (
                  <li key={h} className="flex items-start gap-3 text-sm text-slate-600">
                    <Check className="w-4 h-4 text-sky-600 mt-0.5 shrink-0" />
                    {h}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`service-cta-${i}`}
                onClick={() => scrollToId("contact")}
                className="mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-sky-600 hover:text-sky-600 transition-colors"
              >
                Demander cette solution
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
